// Sincronizado com StatusInventarioEnum do backend ATS.Hub.API.Suprimentos
export enum StatusInventarioEnum {
  Pendente = 1,
  EmProcessamento = 2,
  Falha = 3,
  Cancelado = 4,
  Concluido = 5,
  AguardandoProcessamento = 6,
}
